import React from "react";

//component
import FamilyClanLevelTable from "../component/table/FamilyClanLevels";

const FamilyClanLevels = () => {
  return (
    <div className="mainDashboard">
      <div className="row">
        <div className="col-md-12">
          <FamilyClanLevelTable />
        </div>
      </div>
    </div>
  );
};

export default FamilyClanLevels;
